import { render, staticRenderFns } from "./ReviewMaterialsView.vue?vue&type=template&id=2e026b09&scoped=true&"
import script from "./ReviewMaterialsView.vue?vue&type=script&lang=js&"
export * from "./ReviewMaterialsView.vue?vue&type=script&lang=js&"
import style0 from "./ReviewMaterialsView.vue?vue&type=style&index=0&id=2e026b09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e026b09",
  null
  
)

export default component.exports